import UI from './utils/UI'

UI({
  component: '.js-star-rating'
}, ({ component }) => {
  if (!component) return
  // const ratingText = component.querySelector('.post-ratings-text')
  const ratingImages = component.querySelectorAll('.post-ratings > img')
  const ratingNotSelectedImages = component.querySelectorAll('.post-ratings > img:not(.post-ratings-image)')
  const newStarLink = '/wp-content/themes/kaliber-fair-trade-original/assets/images/star.png'
  const newStarHover = '/wp-content/themes/kaliber-fair-trade-original/assets/images/star-hover.png'
  const newGrayStarLink = '/wp-content/themes/kaliber-fair-trade-original/assets/images/star-gray.png'

  // if (ratingText) { ratingText.remove() }

  ratingImages.forEach(element => {
    if (element.src.includes('rating_on.gif')) {
      element.src = newStarLink
    } else if (element.src.includes('rating_off.gif')) {
      element.src = newGrayStarLink
    } else if (element.src.includes('rating_over.gif')) {
      element.src = newStarHover
    }
  })

  ratingNotSelectedImages.forEach(element => {

    element.addEventListener('mouseover', function(event) {
      const $otherStars = getSiblings(this)

      if (this.src.includes('rating_over.gif')) {
        this.src = newStarHover
      }

      $otherStars.forEach(element => {
        if (element.src.includes('rating_over.gif')) {
          element.src = newStarHover
        } else if (element.src.includes('rating_off.gif')) {
          element.src = newGrayStarLink
        }
      })
    })

    element.addEventListener('click', function(event) {
      let timesRun = 0

      const interval = setInterval(() => {
        timesRun += 1

        if (timesRun === 10) {
          clearInterval(interval)
        }

        component.querySelectorAll('.post-ratings > img').forEach(element => {
          if (element.src.includes('rating_on.gif')) {
            element.src = newStarLink
          } else if (element.src.includes('rating_off.gif')) {
            element.src = newGrayStarLink
          } else if (element.src.includes('rating_over.gif')) {
            element.src = newStarHover
          }
        })
      }, 100)
    })

    element.addEventListener('mouseout', function(event) {
      ratingNotSelectedImages.forEach(element => {
        element.src = newGrayStarLink
      })
    })
  })
})

const getSiblings = function (elem) {
  // Setup siblings array and get the first sibling
  const siblings = []
  let sibling = elem.parentNode.firstChild

  // Loop through each sibling and push to the array
  while (sibling) {
    if (sibling.nodeType === 1 && sibling !== elem) {
      siblings.push(sibling)
    }
    sibling = sibling.nextSibling
  }

  return siblings
}
